import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PermissionRequiredDirective } from '../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { DeveloperSystemInitStepConfigComponent } from './developer-system-init-step-config.component';
import { DeveloperPartnerFallbackResolverComponent } from './developer-partner-fallback-resolver.component';

@Component({
  selector: 'app-developer-system-init-steps',
  templateUrl: './developer-system-init-steps.component.html',
  styleUrls: ['./developer-system-init-steps.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DeveloperSystemInitStepConfigComponent, DeveloperPartnerFallbackResolverComponent]
})
export class DeveloperSystemInitStepsComponent {
}
